/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-21 11:59:36
 * @Description: feature页面
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/feature/index.js
 */
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";
// import Steam from '../steam'
// import Share from '../share'

import './index.scss';
import 'swiper/css';
import "swiper/css/navigation";
// import "swiper/css/pagination";
import fanyi2 from '../../img/web_img_fanye2.png'
import fanyi1 from '../../img/web_img_fanye1.png'

import fe1 from '../../img/fe1.png'
import fe2 from '../../img/fe2.png'
import fe3 from '../../img/fe3.png'
import fe4 from '../../img/fe4.png'
import fe5 from '../../img/fe5.png'
import fe6 from '../../img/fe6.png'
import fe7 from '../../img/fe7.png'
import fe8 from '../../img/fe8.png'
import fe9 from '../../img/fe9.png'
import fe10 from '../../img/fe10.png'
import fe11 from '../../img/fe11.png'
import fe12 from '../../img/fe12.png'




const Feature = () => {
  const [current, setCurrent] = useState(0);
  // const featureList = [
  //   {
  //     img: "https://starvr-cdn.starmakerstudios.com/webimg/home/1.jpg"
  //   },
  //   {
  //     img: "https://starvr-cdn.starmakerstudios.com/webimg/home/2.jpg"
  //   },
  //   {
  //     img: "https://starvr-cdn.starmakerstudios.com/webimg/home/3.jpg"
  //   },
  //   {
  //     img: "https://starvr-cdn.starmakerstudios.com/webimg/home/4.jpg"
  //   },
  //   {
  //     img: "https://starvr-cdn.starmakerstudios.com/webimg/home/5.jpg"
  //   }
  // ]
  const featureList = [
    {
      img: fe1
    },
    {
      img: fe2
    },
    {
      img: fe3
    },
    {
      img: fe4
    },
    {
      img: fe5
    },
    {
      img: fe6
    },
    {
      img: fe7
    },
    {
      img: fe8
    },
    {
      img: fe9
    },
    {
      img: fe10
    },
    {
      img: fe11
    },
    {
      img: fe12
    },
  ]
  return (
    <div className="feature">
      <div className='flex items-center justify-center h-full'>
        <div className='w-2/3'>
          <div className='px-12 swiper-box'>
            <Swiper
              spaceBetween={30}
              effect={"fade"}
              // navigation={true}
              // pagination={{
              //   clickable: false,
              // }}
              modules={[Navigation]}
              navigation={{
                prevEl: '.feature-prev',
                nextEl: '.feature-next',
              }}
              onSlideChange={(e) => {
                console.log('slide change', e.activeIndex)
                setCurrent(e.activeIndex)
              }}
            // onSwiper={(swiper) => console.log(swiper)}
            >
              {featureList && featureList.map((item) => {
                return (
                  <SwiperSlide key={item.img}>
                    <img src={item.img} alt='' />
                  </SwiperSlide>
                )
              })}
            </Swiper>
            <div className={`feature-prev `}>
              {current === 0 ? <img src={fanyi1} alt='' /> : <img className='fanyi2' src={fanyi2} alt='' />}
            </div>
            <div className={`feature-next`}>
              {current === featureList.length-1 ? <img className='fanyi1' src={fanyi1} alt='' /> : <img src={fanyi2} alt='' />}
            </div>
          </div>
        </div>
      </div>
      {/* <Steam/>
      <Share/> */}
    </div>
  );
}

export default Feature;
